/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Full_Otter_GrowInputs */

const en_sharp_full_otter_grow = /** @type {(inputs: Sharp_Full_Otter_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy data from report`)
};

const de_sharp_full_otter_grow = /** @type {(inputs: Sharp_Full_Otter_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten aus Report kopieren`)
};

/**
* | output |
* | --- |
* | "Copy data from report" |
*
* @param {Sharp_Full_Otter_GrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sharp_full_otter_grow = /** @type {((inputs?: Sharp_Full_Otter_GrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Full_Otter_GrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharp_full_otter_grow(inputs)
	return de_sharp_full_otter_grow(inputs)
});